import Vue from 'vue'
import {
  Button,
  Form,
  FormItem,
  Input,
  InputNumber,
  Message,
  Container,
  Header,
  Aside,
  Main,
  Menu,
  Submenu,
  MenuItem,
  Breadcrumb,
  BreadcrumbItem,
  Card,
  Row,
  Col,
  Table,
  TableColumn,
  Switch,
  Tooltip,
  Pagination,
  Dialog,
  MessageBox,
  Tag,
  Tree,
  Select,
  Option,
  Cascader,
  Alert,
  Tabs,
  TabPane,
  DatePicker,
  Collapse,
  CollapseItem,
  ButtonGroup,
  Avatar,
  Popover,
  Drawer,
  Radio,
  RadioGroup,
  Popconfirm,
  RadioButton,
  Loading,
  Link,
  Divider,
  PageHeader,
  Autocomplete,
  CheckboxGroup,
  Checkbox,
  Image,
  Upload
} from 'element-ui'
// 导入弹框提示组件

// 引入组件
import lang from 'element-ui/lib/locale/lang/en'
import locale from 'element-ui/lib/locale'
// 设置语言
locale.use(lang)

Vue.use(Button, Button)
  .use(Form)
  .use(FormItem)
  .use(Input)
  .use(InputNumber)
  .use(Container)
  .use(Header)
  .use(Aside)
  .use(Main)
  .use(Menu)
  .use(MenuItem)
  .use(Submenu)
  .use(Breadcrumb)
  .use(BreadcrumbItem)
  .use(Card)
  .use(Row)
  .use(Col)
  .use(Table)
  .use(TableColumn)
  .use(Switch)
  .use(Tooltip)
  .use(Pagination)
  .use(Dialog)
  .use(Tag)
  .use(Tree)
  .use(Select, Select)
  .use(Option)
  .use(Cascader)
  .use(Alert)
  .use(Tabs)
  .use(TabPane)
  .use(DatePicker)
  .use(DatePicker)
  .use(Collapse)
  .use(CollapseItem)
  .use(ButtonGroup)
  .use(Avatar)
  .use(Popover)
  .use(Tree)
  .use(Drawer)
  .use(Radio)
  .use(RadioGroup)
  .use(Popconfirm)
  .use(RadioButton)
  .use(Loading)
  .use(Link)
  .use(Divider)
  .use(PageHeader)
  .use(Autocomplete)
  .use(CheckboxGroup)
  .use(Checkbox)
  .use(Image)
  .use(Upload)
  
Vue.prototype.$message = Message
Vue.prototype.$confirm = MessageBox.confirm
//点击屏幕不要关闭弹窗
Dialog.props.closeOnClickModal.default = false
